<div class="page-title-group">
  <h2 class="page-title-group__title">
    <ng-content select="[title]"></ng-content>
  </h2>
  <div class="page-title-group__actions">
    <ng-content select="[actions]"></ng-content>
  </div>
</div>
